// Start Gift Icon
$(document).ready(function() {
  
  setTimeout(
  function() 
  {

if($(window).width() < 988) {
             
$("#menu-drawer > div > div > nav > ul > li:nth-child(1) > a > span.gm-icon.gm-icon-img").html("<img src='https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_Xmas_nav_animation-hat.gif?v=1763067778'>");  
              
 } else if ($(window).width() >= 988) {
  
$("div > header > nav > ul > li:nth-child(1) > a > span.gm-icon.gm-icon-img").html("<img src='https://cdn.shopify.com/s/files/1/0855/3804/6232/files/VTB_Xmas_nav_animation-hat.gif?v=1763067778'>");  
     
  
                                        
    };

     }, 1000);
  });
// End Gift Icon

